import pesos from "../helpers/pesosCurrency";
export default function cartView(store) {
    var returnComponent;
    if (store.cart.showAll().length != 0) {
        returnComponent = "\n  <div class=\"cart-content\" id=\"main-content\">\n    <table class=\"cart-content-table\">\n      <thead>\n        <tr>\n          <th><h2>Producto</h2></th>\n          <th><h2>Acciones</h2></th>\n        </tr>\n      </thead>\n      <tbody id=\"cart-table\">\n        <!-- javascript rendered -->\n      </tbody>\n      <tfooter>\n        <tr>\n          <th><h2>Monto total</h2></th>\n          <th><h2 id=\"final-price\">" + pesos.format(store.cart
            .showAll()
            .map(function (previousValue) {
            return (previousValue.amount *
                previousValue.item.getPriceWithDiscount());
        })
            .reduce(function (a, b) { return a + b; })) + "</h2></th>\n        </tr>\n      </tfooter>\n    </table>\n\n    <button class=\"button-link\" id=\"clean-cart-btn\">\n      Vaciar Carrito\n    </button>\n  </div>\n  ";
    }
    else {
        returnComponent = "\n  <div class=\"cart-content\" id=\"main-content\">\n    <h1>Usted no posee art\u00EDculos en su carrito</h1>\n  </div>\n  ";
    }
    return returnComponent;
}
